import { useEffect } from 'react';

const useCallbackUri = (callbackUri: string | undefined) => {
  useEffect(() => {
    if (callbackUri) {
      document.getElementsByTagName('header')[0].style.display = 'none';
      document.getElementsByTagName('aside')[0].style.display = 'none';
    }
  }, [callbackUri]);
};

export default useCallbackUri;
